<template>
  <div class="registerb">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" >
      <div class="Rtitle">
        <span class="titlel">{{InsName}}</span><span class="titler"> | 找回密码</span>
      </div>
      <div class="Rmin" v-show="insTestProp.UserRelyPhone">
      <el-form-item prop="name">
        <div class="error3">
         <span class="colorr">*</span> <span>用户代码:</span>
        </div>
        <el-input v-model.trim="ruleForm.name" placeholder="请输入用户代码" id="name"></el-input>
      </el-form-item>
      <el-form-item prop="phone">
        <div class="error3">
         <span class="colorr">*</span> 手机号:
        </div>
        <el-input v-model.trim="ruleForm.phone" placeholder="请输入手机号" id="phone"></el-input>
        <span class="error4 hint">请填写账户绑定的手机号码.</span>
      </el-form-item>
      <el-form-item prop="imgcode">
        <div class="error3">
         <span class="colorr">*</span> 图形验证码:
        </div>
        <el-input v-model.trim="ruleForm.imageCode" placeholder="请输入图形验证码" id="imgcode"></el-input>
        <img :src="imgurl" alt="" class="imgcode" @click="GetImgCheckCode()">     
      </el-form-item>
      <el-form-item prop="phoneCode">
        <div class="error3">
         <span class="colorr">*</span> 手机验证码:
        </div>
        <el-input v-model.trim="ruleForm.phoneCode" placeholder="请输入的验证码"  id="code"></el-input>
        <el-button type="primary" size="small" @click="sendCode('ruleForm')" :disabled="isDisabled">{{buttonName}}</el-button>
      </el-form-item>
        <div class="bbtn">
          <el-button type="primary" @click="submitForm('ruleForm')" class="submit" :disabled="this.isDisableds">确认</el-button>
          <el-button @click="resetForm('ruleForm')" class="submit">重置</el-button>
        </div>
      </div>
      <div style="font-size: 32px;text-align: center" v-show="!insTestProp.UserRelyPhone">
        请联系管理员!
      </div>
    </el-form>
  </div>

</template>

<script>
import "../assets/lib/jquery.min.js";

export default {
  name: "forgetPswd",
  data() {
    var reg = /^1[35789]\d{9}$/;
    var validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电话号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的11位手机号码"));
      } else {
        callback();
        this.codephone = true;
      }
    };
    return {
      isDisableds: false,
      codephone: false,
      checked: false,
      buttonName: "发送短信验证码",
      isDisabled: false,
      time: 60,
      ruleForm: {
        name: "",
        phone: "",
        phoneCode: "",
        InsCode: "",
        imageCode:""
      },
      rules: {
        name: [
          {
            required: true,
            min: 2,
            max: 50,
            message: "请输入真实姓名",
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, trigger: "blur", validator: validPhone } //这里需要用到全局变量
        ],
        // imgcode: [
        //   { required: true, trigger: "blur",  } //这里需要用到全局变量
        // ],
        phoneCode: [
          {
            required: true,
            message: "请输入正确的验证码",
            trigger: "blur"
          }
        ]
      },
      path: "",
      imgurl:"",
      InsName: "",
      imageCheckSign:"",
      insTestProp: {
        IsTestIns: true, // 是否测试机构，true测试机构
        UserRelyPhone: true, // 依赖手机号
        UseCustomId: true // 使用自定义ID,false表示使用系统自动生成，true表示使用自定义ID
      }
    };
  },
  created() {
    this.InsName = JSON.parse(sessionStorage.getItem("InsNameCn"));
    // this.insTestProp = JSON.parse(sessionStorage.getItem("insTestProp"));
    document.getElementsByTagName("title")[0].innerText = "忘记密码";
    var pswdpageiscode = sessionStorage.getItem("pswdpageiscode");

    if (pswdpageiscode == null) {

      pswdpageiscode = window.location.hash.split("?")[0].split("/");

      this.ruleForm.InsCode = pswdpageiscode[2];

    } else {

      this.ruleForm.InsCode = pswdpageiscode.split("/")[2];
    }

    let postData = "insCode=" +  this.ruleForm.InsCode;
        let url = "/register/GetInsTestProp";
        this.$api.post(url,postData, response => {
          if (response.Ret == 0) {

            this.insTestProp = response.Data;

          } else {
            this.$message.error(response.Msg);
          }
        });
    this.GetImgCheckCode();
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
        //  获取图形验证码
    GetImgCheckCode(){
        this.$api.post(
        "/login/GetImgCheckCode",
        "",
        response => {
            if (response.Ret == 0) {  
              this.imgurl = "data:image/png;base64," + response.Data.ImageBase64;
              this.ImageCheckSign = response.Data.ImageCheckSign;
            } else {
              this.$message.error(response.Msg);    
            }
        });           
    },
    // 确认按钮
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid === true) {
          this.isDisableds = true;
          let url = "/register/ForgetPassword";
          let postData =
            "UserCode=" +
            this.ruleForm.name +
            "&Phone=" +
            this.ruleForm.phone +
            "&Code=" +
            this.ruleForm.phoneCode +
            "&InsCode=" +
            this.ruleForm.InsCode;
          this.$api.post(url, postData, response => {
            this.isDisableds = false;
            if (response.Ret == 0) {
              vue.$message.success("密码重置成功！自动跳转登录页面！");
              $("#name").val("");
              $("#phone").val("");
              $("#code").val("");
              var _this = this;
              setTimeout(() => {
                _this.$router.push("/Login/" + _this.ruleForm.InsCode);
              }, 1000);
            } else {
              this.$message.error(response.Msg);
              this.resetForm("ruleForm");
            }
          });
        } else {
          vue.$message.error("信息输入有误！");
          return false;
        }
      });
    },
    //获取验证码
    sendCode(formName) {
      this.isDisabled = true;
      this.$refs[formName].validateField("phone", valid => {
        if (valid === "") {
          let url = "register/ForgetPasswordSendSmsCode";
          // let Phone = "phone=" + this.ruleForm.phone;
          this.$api.post(url, 
          "insCode=" + this.ruleForm.InsCode + "&userCode=" + this.ruleForm.name + "&phone=" + this.ruleForm.phone + "&imageCode=" + this.ruleForm.imageCode + "&imageCheckSign=" + this.ImageCheckSign,
           response => {
             this.isDisabled = false;
             this.GetImgCheckCode();
            if (response.Ret == 0) {
              this.$message.success("验证码已发送，请注意查收!");
              this.sendMsg();
              this.codephone = false;
            } else {
              this.$message.error(response.Msg);
            }
          });
        } else {
          this.isDisabled = false;
          vue.$message.error("信息输入有误！");
          return false;
        }
      });
    },
    // 短信验证倒计时
    sendMsg() {
      let me = this;
      me.isDisabled = true;
      let interval = window.setInterval(function() {
        me.buttonName = "（" + me.time + "s）发送";
        --me.time;
        if (me.time < 0) {
          me.buttonName = "发送短信验证码";
          me.time = 60;
          me.isDisabled = false;
          window.clearInterval(interval);
        }
      }, 1000);
    }
  }
};
</script>


<style scoped>
.el-input {
  width: 50% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/forgetPswd.vue